/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParcBienTypesResponse
 */
export interface ParcBienTypesResponse {
    /**
     * Types de biens (TypeBienImmobilierEnum) présents dans le parc
     * @type {Array<number>}
     * @memberof ParcBienTypesResponse
     */
    types: Array<number>;
}

/**
 * Check if a given object implements the ParcBienTypesResponse interface.
 */
export function instanceOfParcBienTypesResponse(value: object): value is ParcBienTypesResponse {
    if (!('types' in value) || value['types'] === undefined) return false;
    return true;
}

export function ParcBienTypesResponseFromJSON(json: any): ParcBienTypesResponse {
    return ParcBienTypesResponseFromJSONTyped(json, false);
}

export function ParcBienTypesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParcBienTypesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'types': json['types'],
    };
}

export function ParcBienTypesResponseToJSON(json: any): ParcBienTypesResponse {
    return ParcBienTypesResponseToJSONTyped(json, false);
}

export function ParcBienTypesResponseToJSONTyped(value?: ParcBienTypesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'types': value['types'],
    };
}

